import React from "react"
import Navbar from './Navbar'
import { Footer } from '.';
import { TrustpilotCarousel, Newsletter, Cta, RecentBlogPosts } from '../components';

const ServicesLayout = ({ children }) => {
    return (
        <>
            <Navbar />
            <main>
                {children}
                <Cta />
                <RecentBlogPosts />
                <TrustpilotCarousel />
                <Newsletter />
            </main>
            <Footer />
        </>
    )
}

export default ServicesLayout